import { StockParentModelType } from '@teinor/erp/types/company/product/stockParent'
import { useMemo } from 'react'
import { ModalCreateEditLoading } from '../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../../utils/globals/valueOrDefaultValue'
import { useBasicData } from '../../../../../../utils/hooks/useBasicData'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { getActiveCurrenciesDictionary } from '../../../../../../utils/reducers/getters'

interface ModalEditStockProductProps extends ModalEditComponentProps { }

const ModalEditStockProduct: React.FC<ModalEditStockProductProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { basicData } = useBasicData({ params: { id: allRowData?.id }, url: '/api/app/product/stock/getStockParentInstance' })
    const {t} = useTwinTranslation()
    const dictActiveCurrencies = useMemo(() => getActiveCurrenciesDictionary() || {}, [])
    const fields: FormRender<StockParentModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'ProductId',
                    component: 'InputHidden',
                },
                {
                    name: 'WarehouseId',
                    label: t('warehouse', 'Almacén'),
                    component: 'CustomSelectWithSearchBar',
                    items: basicData?.Warehouse ? { [basicData?.Warehouse.id]: basicData?.Warehouse } : {},
                    required: true,
                    readOnly: true,
                },
                {
                    name: 'CurrencyId',
                    label: t('currency', 'Moneda'),
                    component: 'CustomSelectWithSearchBar',
                    items: dictActiveCurrencies,
                    required: true
                },
                {
                    name: 'location',
                    label: t('location', 'Localización'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'minimum',
                    label: t('minimum', 'Mínimo'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'optimum',
                    label: t('optimum', 'Óptimo'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                },
            ],
        },
    ]
    if (userPermissions && allRowData) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, basicData || {})
        return (
            <ModalCreateEditLoading className='notFlexAutoFormRender' fields={parsedFields} url={'/api/app/product/stock/updateParentStock'} translations={{
                title: t('editStock', 'Editar inventario') + ' - ' + allRowData?.basicData?.name,
                button: t('save', 'Guardar')
            }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} loading={basicData === null} />
        )
    }
    return (null)
}


export default ModalEditStockProduct